import { Collapse, Stack } from "@mui/material";
import { useState } from "react";
import { useMomentAnalyticsContext } from "../context/moment-stats-context";
import { AnalyticsOverviewContent } from "./content";
import { AnalyticsOverviewHeader } from "./header";
import { AnalyticsHelpButton } from "./help-button";

import type { AnalyticsMoment } from "../types";
import type { FC } from "react";

export const AnalyticsOverview: FC<{ moment: AnalyticsMoment }> = ({ moment }) => {
  const [expanded, setExpanded] = useState(true);

  const { totals } = useMomentAnalyticsContext();

  if (!totals) return null;

  const { loading, error, data } = totals;

  if (error) return "Error loading Communication history";

  return (
    <Stack spacing={2}>
      <AnalyticsOverviewHeader
        onHeaderClick={() => setExpanded(!expanded)}
        expanded={expanded}
        sentTimes={data?.total_sends ?? 0}
        loading={loading}
        moment_id={moment.id}
      />
      <Collapse in={expanded}>
        <Stack spacing={4}>
          <AnalyticsOverviewContent
            loading={loading}
            data={data}
            channel_name={moment.channel}
            target_channel={moment.target_channel ?? false}
          />
          <AnalyticsHelpButton />
        </Stack>
      </Collapse>
    </Stack>
  );
};
